import { Link } from 'react-router-dom';

export default function ReviewSection() {
  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-5xl mx-auto">
          <div className="text-center mb-12">
            <span className="inline-block px-3 py-1 bg-secondary-100 text-secondary-700 text-xs font-medium rounded-full mb-3">
              Honest Review
            </span>
            <h2 className="font-heading text-2xl md:text-4xl font-semibold text-foreground-900 mb-4">
              Basetao Review: Is Basetao Legit?
            </h2>
            <p className="text-sm text-foreground-600 max-w-xl mx-auto">
              An independent, transparent assessment of the Basetao shopping agent platform
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div>
              <h3 className="font-heading text-xl font-semibold text-foreground-900 mb-4">What Is Basetao?</h3>
              <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                Basetao is a <strong>well-established Chinese shopping agent</strong> that has served international buyers for years. The platform allows customers worldwide to purchase products from Chinese marketplaces including <strong>Taobao, Tmall, and 1688</strong>, even when those platforms do not ship internationally.
              </p>
              <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                Basetao acts as your intermediary — they purchase items on your behalf, receive them at their warehouse, provide <strong>quality inspection photos</strong>, and then ship everything to your doorstep using your preferred international carrier.
              </p>

              <h4 className="font-semibold text-foreground-900 mt-6 mb-3">Pros &amp; Cons</h4>
              <div className="space-y-2 text-sm">
                <div className="flex items-start gap-2">
                  <span className="text-accent-600 mt-0.5"><i className="ri-add-circle-line"></i></span>
                  <span className="text-foreground-700">Free warehouse storage for up to 180 days</span>
                </div>
                <div className="flex items-start gap-2">
                  <span className="text-accent-600 mt-0.5"><i className="ri-add-circle-line"></i></span>
                  <span className="text-foreground-700">Professional QC inspection photos included</span>
                </div>
                <div className="flex items-start gap-2">
                  <span className="text-accent-600 mt-0.5"><i className="ri-add-circle-line"></i></span>
                  <span className="text-foreground-700">Multiple shipping carriers and methods available</span>
                </div>
                <div className="flex items-start gap-2">
                  <span className="text-secondary-600 mt-0.5"><i className="ri-indeterminate-circle-line"></i></span>
                  <span className="text-foreground-700">Service fees apply on each transaction</span>
                </div>
                <div className="flex items-start gap-2">
                  <span className="text-secondary-600 mt-0.5"><i className="ri-indeterminate-circle-line"></i></span>
                  <span className="text-foreground-700">Website interface can feel dated compared to newer competitors</span>
                </div>
              </div>
            </div>

            <div className="bg-background-50 rounded-lg border border-background-200/60 p-6">
              <h4 className="font-semibold text-foreground-900 mb-4">Quick Comparison</h4>
              <table className="w-full text-sm">
                <thead>
                  <tr className="border-b border-background-200/60">
                    <th className="text-left py-2.5 text-foreground-500 font-medium">Feature</th>
                    <th className="text-left py-2.5 text-accent-700 font-medium">Basetao</th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="border-b border-background-200/40">
                    <td className="py-2.5 text-foreground-600">Warehouse Storage</td>
                    <td className="py-2.5 text-foreground-900">Available (Free period)</td>
                  </tr>
                  <tr className="border-b border-background-200/40">
                    <td className="py-2.5 text-foreground-600">QC Photos</td>
                    <td className="py-2.5 text-foreground-900">Included</td>
                  </tr>
                  <tr className="border-b border-background-200/40">
                    <td className="py-2.5 text-foreground-600">Shipping Options</td>
                    <td className="py-2.5 text-foreground-900">Multiple carriers</td>
                  </tr>
                  <tr className="border-b border-background-200/40">
                    <td className="py-2.5 text-foreground-600">Order Management</td>
                    <td className="py-2.5 text-foreground-900">Spreadsheet friendly</td>
                  </tr>
                  <tr>
                    <td className="py-2.5 text-foreground-600">Customer Support</td>
                    <td className="py-2.5 text-foreground-900">English available</td>
                  </tr>
                </tbody>
              </table>

              <p className="mt-5 text-xs text-foreground-500 italic">
                Disclaimer: This website provides independent educational information and is not officially affiliated with or endorsed by Basetao. All trademarks belong to their respective owners.
              </p>
            </div>
          </div>

          <div className="text-center mt-8">
            <Link
              to="/basetao-spreadsheet-guide"
              className="inline-flex items-center gap-2 text-sm font-medium text-accent-600 hover:text-accent-700 transition-colors cursor-pointer"
            >
              Read the full in-depth review <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}